var map = {
	"./GoldAlpha.png": 756,
	"./GoldBeta.png": 757,
	"./GoldChi.png": 758,
	"./GoldDelta.png": 759,
	"./GoldEpsilon.png": 760,
	"./GoldEta.png": 761,
	"./GoldGamma.png": 762,
	"./GoldIota.png": 763,
	"./GoldKappa.png": 764,
	"./GoldLambda.png": 765,
	"./GoldMu.png": 766,
	"./GoldNu.png": 767,
	"./GoldOmega.png": 768,
	"./GoldOmicron.png": 769,
	"./GoldPhi.png": 770,
	"./GoldPi.png": 771,
	"./GoldPsi.png": 772,
	"./GoldRho.png": 773,
	"./GoldSigma.png": 774,
	"./GoldTau.png": 775,
	"./GoldTheta.png": 776,
	"./GoldUpsilon.png": 777,
	"./GoldXi.png": 778,
	"./GoldZeta.png": 779
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1325;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold ^\.\/Gold.*\.png$
// module id = 1325
// module chunks = 0